import "./components/Assets/Styles/global.css";
import "./App.scss";
import Main from "./Main";
import { Provider } from "react-redux";
import store from "./utils/redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <div className='App'>
        <Main />
      </div>
    </Provider>
  );
}

export default App;
